import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  UpcomingEvents: [],
  Events: [],
  EventsObject: null,
  EventHistory: [],
  EventDetails: null,
  EventBudget: null,
  EventBudgetCat: [],
  AllBudget: [],
  Weekly_CheckList: {},
  Monthly_CheckList: {},
  All_CheckList: {},
  calendarChecklist: {},
  ReminderList: [],
  Timeline: [],
  liveChannelData: [],
  ClientPlanningForm: [],
  ClientSection: [],
  ClientSubSection: [],
  ClientQuestion: [],
  WeddingWall: [],
  WeddingWeb: null,
};

const EventReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.UPCOMING_EVENTS:
      state = { ...state, UpcomingEvents: action.payload };
      break;
    case ActionTypes.EVENTS_HISTORY:
      state = { ...state, EventHistory: action.payload };
      break;
    case ActionTypes.EVENT_DETAIL:
      state = { ...state, EventDetails: action.payload };
      break;
    case ActionTypes.UPDATE_EVENT:
      let Update_Event_List_Copy = [...state.UpcomingEvents];
      Update_Event_List_Copy.unshift(action.payload);
      state = {
        ...state,
        UpcomingEvents: Update_Event_List_Copy,
      };
      break;
    case ActionTypes.EDIT_EVENT:
      let Edit_Event_List_Copy = [...state.UpcomingEvents];
      let index = Edit_Event_List_Copy.findIndex(
        (item) => item?.id == action?.payload?.id
      );
      Edit_Event_List_Copy.splice(index, 1, action?.payload);

      state = {
        ...state,
        UpcomingEvents: Edit_Event_List_Copy,
      };
      break;
    case ActionTypes.DELETE_EVENT:
      let Delete_Event_List_Copy = [...state.UpcomingEvents];
      let indexDel = Delete_Event_List_Copy.findIndex(
        (item) => item?.id == action?.payload
      );
      Delete_Event_List_Copy.splice(indexDel, 1);
      state = {
        ...state,
        UpcomingEvents: Delete_Event_List_Copy,
      };
      break;

    case ActionTypes.EVENT_BUDGET:
      state = {
        ...state,
        EventBudget: action?.payload,
        AllBudget: action?.payload?.tracker,
      };
      break;
    case ActionTypes.EVENT_BUDGET_CAT:
      state = {
        ...state,
        EventBudgetCat: action?.payload,
      };
      break;

    case ActionTypes.CLEAR_DETAIL:
      state = { ...state, EventDetails: null };
      break;

    case ActionTypes.WEEKLY_CHECKLIST:
      state = { ...state, Weekly_CheckList: action.payload };
      break;

    case ActionTypes.MONTHLY_CHECKLIST:
      state = { ...state, Monthly_CheckList: action.payload };
      break;

    case ActionTypes.ALL_CHECKLIST:
      state = { ...state, All_CheckList: action.payload };
      break;

    case ActionTypes.CLEAR_CHECKLIST:
      state = {
        ...state,
        Weekly_CheckList: {},
        Monthly_CheckList: {},
        All_CheckList: {},
      };
      break;

    case ActionTypes.CALENDAR_CHECKLIST:
      state = { ...state, calendarChecklist: action.payload };
      break;

    case ActionTypes.GET_EVENT_REMINDER:
      state = { ...state, ReminderList: action.payload };
      break;
    case ActionTypes.GET_EVENT_TIMELINE:
      state = { ...state, Timeline: action.payload };
      break;
    case ActionTypes.GET_LIVE_CHANNEL_DATA:
      state = { ...state, liveChannelData: action.payload };
      break;

    case ActionTypes.GET_CLIENT_PLANNING_FORM:
      state = { ...state, ClientPlanningForm: action.payload };
      break;

    case ActionTypes.GET_CLIENT_SECTION:
      state = { ...state, ClientSection: action.payload };
      break;
    case ActionTypes.GET_CLIENT_SUB_SECTION:
      state = { ...state, ClientSubSection: action.payload };
      break;

    case ActionTypes.GET_CLIENT_QUESTION:
      state = { ...state, ClientQuestion: action.payload };
      break;

    case ActionTypes.GET_WEDING_WALL:
      state = { ...state, WeddingWall: action.payload };
      break;

    case ActionTypes.GET_WEDING_WEB:
      state = { ...state, WeddingWeb: action.payload };
      break;

    default:
      break;
  }
  return state;
};

export default EventReducer;
